import { render, staticRenderFns } from "./ClubChat.vue?vue&type=template&id=1535af8e&"
import script from "./ClubChat.vue?vue&type=script&lang=js&"
export * from "./ClubChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports